var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7666_9606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4495 17.5607C27.7081 19.0063 26.2053 19.9998 24.4716 19.9998C22.738 19.9998 21.2358 19.0063 20.4938 17.5607H3.3335V33.0081H28.6551C27.822 32.0177 27.317 30.7425 27.317 29.3496C27.317 26.6307 29.2355 24.3537 31.7885 23.7935V17.5607H28.4495V17.5607ZM17.561 30.1627C14.8672 30.1627 12.6827 27.9782 12.6827 25.2844C12.6827 22.5905 14.8665 20.406 17.561 20.406C20.2555 20.406 22.4393 22.5899 22.4393 25.2844C22.4393 27.9788 20.2548 30.1627 17.561 30.1627Z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0071 33.0057C35.0276 33.0057 36.6655 31.3678 36.6655 29.3473C36.6655 27.3268 35.0276 25.6888 33.0071 25.6888C30.9866 25.6888 29.3486 27.3268 29.3486 29.3473C29.3486 31.3678 30.9866 33.0057 33.0071 33.0057Z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4714 17.968C25.8185 17.968 26.9106 16.876 26.9106 15.5289C26.9106 14.1818 25.8185 13.0897 24.4714 13.0897C23.1243 13.0897 22.0322 14.1818 22.0322 15.5289C22.0322 16.876 23.1243 17.968 24.4714 17.968Z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66378 6.99207L7.12256 15.5288H20C20 13.0632 22.0059 11.0573 24.4715 11.0573C26.9371 11.0573 28.943 13.0632 28.943 15.5288H31.7883H33.8207V17.5611V23.7235C34.0628 23.7587 34.3005 23.8078 34.5319 23.8719L36.6667 12.0471L8.66378 6.99207Z",
    fill: "#008BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7666_9606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.3333,
    height: 33.3333,
    fill: "white",
    transform: "translate(3.3335 3.33337)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendDashboard);
export default __webpack_public_path__ + "static/media/send-dashboard.5c692befcac1b66f167b580e8bc851bc.svg";
export { ForwardRef as ReactComponent };